import { palette } from 'app_previous/styles/colors';
import { layout } from 'app_previous/styles/layout';
import styled from 'styled-components';

interface InputMobileButtonProps {
  backgroundColor?: string;
  borderColor?: string;
}

export const InputMobileButton = styled.button<InputMobileButtonProps>`
  border: 1px solid ${({ borderColor }) => borderColor || palette.accentBlue};
  background: ${({ backgroundColor }) => backgroundColor || palette.accentBlue};
  cursor: pointer;
  height: 50px;
  width: 190px;
  min-width: 176px;
  display: none;
  column-gap: 0.5rem;
  justify-content: center;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
  transition: all 0.3s ease-in-out;
  border-radius: 30px;

  @media screen and (max-width: ${layout.sm}) {
    display: flex;
    margin-top: 1rem;
  }
`;
